const Saetze = require('./saetze.js');
import {formatPrice} from './logic';

class Krankenkasse {

    constructor()
    {
        this.kvjung = Saetze.krankenversicherungjung;
        this.kvalt = Saetze.krankenversicherung30;
        this.pfjung = Saetze.pflegeversicherungjung;
        this.pfalt = Saetze.pflegeversicherung30;
    }

    get jung() {
        return this.berechneJung();
    }

    get alt() {
        return this.berechneAlt();
    }

    get null() {
        return this.berechneNull();
    }

    /**
     * Berechne Krankenkassenbeiträge für Personen unter 30
     * @returns {string}
     */
    berechneJung() {
        return formatPrice((this.kvjung + this.pfjung));
    }

    /**
     * Berechne Krankenkassenbeiträge für Personen über 30
     * @returns {string}
     */
    berechneAlt() {
        return formatPrice((this.kvalt + this.pfalt));
    }

    /**
     * Kranenkassenzuschlag 0,00 Ausgeben
     * @returns {string}
     */
    berechneNull() {
        return formatPrice(0);
    }
}

/**
 * Berechnung Krankenkassenzuschlag
 * @param $this
 * @param aus
 */
function krankenzuschlagBerechnen($this, aus = false){
    const kv = new Krankenkasse();
    if(aus){
        $this.el$('results.krankenkassenzuschlag').value = kv.null
    }else {
        if (!$this.el$('Krankenkasse.art').value) { // Art gesetzt?
            //console.log('Krankenkasse.art leer')
        } else if ($this.el$('Krankenkasse.art').value === 'stud') { // Studentisch versichert
            //console.log($this.el$('Krankenkasse.art').value)
            if ($this.el$('Krankenkasse.ue30').value) { // Ü30 gesetzt?
                //console.log($this.el$('Krankenkasse.ue30').value)
                if ($this.el$('Krankenkasse.ue30').value === 'ja') { // über 30
                    $this.el$('results.krankenkassenzuschlag').value = kv.alt
                } else { //unter 30
                    $this.el$('results.krankenkassenzuschlag').value = kv.jung
                }
            } else { // default
                $this.el$('results.krankenkassenzuschlag').value = kv.jung
            }
        } else {
            $this.el$('results.krankenkassenzuschlag').value = kv.null
        }
    }
    //console.log('Krankenkassenzuschlag: '+$this.el$('results.krankenkassenzuschlag').value)
}

/**
 * Funktionen exportieren
 */
export {krankenzuschlagBerechnen};
